export default __webpack_public_path__ + "static/media/bot-action-4-Kellen.47733e67.webm";